module.exports = __webpack_public_path__ + "img/computador_vintage.adef78a8.png";